/**
 * The tag of a notification (D-766): what makes one on screen replace another instead of stacking.
 * The server puts it in every Web Push payload (`webPushTagOf`) and the open tab uses it for its
 * own banner (`NotificationManager`), so a push for something the tab already announced finds that
 * banner (`sw-push.js` looks it up by tag and `notificationId`) and replaces it quietly. They only
 * match if both sides compute the tag the same way, hence one function.
 *
 *   a task event          hub:task:<taskId>
 *   a conversation        hub:<conversationId>
 *   anything else         hub:<notificationId>
 */
export function notificationTag(input: {
  cid?: string | null | undefined;
  taskId?: string | null | undefined;
  notificationId: string;
}): string {
  if (input.taskId) return `hub:task:${input.taskId}`;
  if (input.cid) return `hub:${input.cid}`;
  return `hub:${input.notificationId}`;
}
